import { TypographyProps } from "@mui/material";

export const typographySamples: {
  label: string;
  variant: TypographyProps["variant"];
  description: string;
  example: string;
}[] = [
  {
    label: "Heading 1",
    variant: "h1",
    description: "Used for page titles",
    example: '<Typography variant="h1">Heading 1</Typography>',
  },
  {
    label: "Heading 2",
    variant: "h2",
    description: "Used for section titles",
    example: '<Typography variant="h2">Heading 2</Typography>',
  },
  {
    label: "Heading 3",
    variant: "h3",
    description: "Used for sub-sections",
    example: '<Typography variant="h3">Heading 3</Typography>',
  },
  {
    label: "Heading 4",
    variant: "h4",
    description: "Used for field group titles or cards",
    example: '<Typography variant="h4">Heading 4</Typography>',
  },
  {
    label: "Body 1",
    variant: "body1",
    description: "Default paragraph text",
    example: '<Typography variant="body1">Body 1 text</Typography>',
  },
  {
    label: "Body 2",
    variant: "body2",
    description: "Slightly smaller paragraph text",
    example: '<Typography variant="body2">Body 2 text</Typography>',
  },
  {
    label: "Caption",
    variant: "caption",
    description: "Used for input hints or helper text",
    example: '<Typography variant="caption">Caption text</Typography>',
  },
  {
    label: "Overline",
    variant: "overline",
    description: "Used for subtle section labels",
    example: '<Typography variant="overline">Overline</Typography>',
  },
];
